module.exports = __webpack_public_path__ + "4d87ceafd8d771437706d339ea1792be.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/fonts/bulorounded-regularitalic.ttf
 ** module id = 11
 ** module chunks = 0
 **/